'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupConnection = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSetupConnection = exports.DeviceSetupConnection = function (_React$Component) {
  (0, _inherits3.default)(DeviceSetupConnection, _React$Component);

  function DeviceSetupConnection() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, DeviceSetupConnection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = DeviceSetupConnection.__proto__ || (0, _getPrototypeOf2.default)(DeviceSetupConnection)).call.apply(_ref, [this].concat(args))), _this2), _this2.getNoConnectionScreen = function () {
      var handleStandardPlay = _this.props.handleStandardPlay;


      return [_react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top', key: 'device.connection.top' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.header-failed',
          defaultMessage: 'Connection unsuccessful',
          tagName: 'h3'
        }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.suggestion',
          defaultMessage: 'We\u2019re having trouble connecting to your heart rate monitor. Try to un-snap and re-snap the Wahoo TICKR sensor.',
          tagName: 'p'
        })
      ), _react2.default.createElement(
        'div',
        { className: 'modal__device-connection modal__device-setup__content', key: 'device.connection.content' },
        _react2.default.createElement('img', {
          src: require('../../../static/img/setup-device.svg'),
          alt: 'No Connection',
          className: 'modal__device-connection__no-wearable p++'
        }),
        _react2.default.createElement(
          'button',
          {
            className: 'bt bt--primary mt+',
            onClick: _this.props.connectBluetoothDevice // eslint-disable-line react/jsx-handler-names
            , key: 'device.connection.button'
          },
          'Try connecting again'
        ),
        _react2.default.createElement(
          'div',
          { id: 'connection-error', className: 'mt' },
          _react2.default.createElement(
            'p',
            { className: 'inline-block' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'connection-error-prompt',
              defaultMessage: 'Having trouble connecting?'
            })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: function onClick() {
                return handleStandardPlay();
              }, className: 'md-inline-block sm-block pl- mt+' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'connection-error-play-video',
              defaultMessage: 'Watch video only'
            })
          )
        )
      )];
    }, _this2.getConnectedScreen = function () {
      var device = _this.props.device;


      return [_react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top', key: 'device.connection.top' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.current-hr',
            defaultMessage: 'Your current heart rate'
          })
        )
      ), _react2.default.createElement(
        'div',
        { className: 'modal__device-connection modal__device-setup__content', key: 'device.connection.content' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'modal__device-connection__bpm' },
            device.bpm || '--'
          ),
          _react2.default.createElement(
            'span',
            { className: 'modal__device-connection__bpm-label' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'device.heart.rate',
              defaultMessage: 'Heart rate'
            })
          ),
          _react2.default.createElement(
            'span',
            { className: 'inline-block mv+' },
            _react2.default.createElement(_reactInlinesvg2.default, { className: 'modal__device-connection__device-label svg mr--', src: require('../../../static/img/icon/bluetooth-teal.svg') }),
            _react2.default.createElement(
              'span',
              { className: 'modal__device-connection__device-label' },
              device.connection
            )
          )
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)('bt bt--primary bt--width-md mt+', {
              'bt--disabled': !device.bpm
            }),
            disabled: !device.bpm,
            onClick: _this.handleConnectionComplete,
            key: 'device.connection.button'
          },
          'Next'
        )
      )];
    }, _this2.handleConnectionComplete = function () {
      var _this$props = _this.props,
          alias = _this$props.alias,
          inSession = _this$props.inSession,
          hideModal = _this$props.hideModal,
          updateDevice = _this$props.updateDevice,
          joinClass = _this$props.joinClass;


      if (inSession) {
        // resuming an existing session so we need to
        // ensure we join the class again to setup the
        // state of the bluetooth flow and leaderboard
        // flow correctly.
        joinClass(alias, 'INTERACTIVE');
        hideModal('DeviceSetupModal');
      } else {
        updateDevice({ status: _bluetooth2.default.READY_TO_CAST });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(DeviceSetupConnection, [{
    key: 'getPairingScreenStage1',
    value: function getPairingScreenStage1() {
      return [_react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top', key: 'device.connection.top' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.pairing-header',
          defaultMessage: 'Pairing heart rate monitor',
          tagName: 'h3'
        })
      ), _react2.default.createElement(
        'div',
        { className: 'modal__device-connection modal__device-setup__content', key: 'device.connection.content' },
        _react2.default.createElement('img', { src: require('../../../static/img/bluetooth.gif'), className: 'modal__device-connection__connect-animation', alt: 'bluetooth' }),
        _react2.default.createElement(
          'p',
          { className: 'text--light m+' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.pairing-message',
            defaultMessage: 'Pairing with your device...'
          })
        )
      )];
    }
  }, {
    key: 'getPairingScreenStage2',
    value: function getPairingScreenStage2() {
      return [_react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top', key: 'device.connection.top' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.pairing-hr-header',
          defaultMessage: 'Pairing heart rate monitor',
          tagName: 'h3'
        })
      ), _react2.default.createElement(
        'div',
        { className: 'modal__device-connection modal__device-setup__content', key: 'device.connection.content' },
        _react2.default.createElement('img', { src: require('../../../static/img/heart.gif'), className: 'modal__device-connection__connect-animation', alt: 'heart' }),
        _react2.default.createElement(
          'p',
          { className: 'text--light m+' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.reading-hr-message',
            defaultMessage: 'Reading heart rate...'
          })
        )
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      var device = this.props.device;


      return _react2.default.createElement(
        'div',
        { className: 'modal__device-connection' },
        [_bluetooth2.default.DEVICE_DISCONNECTED, _bluetooth2.default.DEVICE_FAILED].indexOf(device.status) > -1 && this.getNoConnectionScreen(),
        device.status === _bluetooth2.default.DEVICE_CONNECTED && this.getConnectedScreen(),
        [_bluetooth2.default.DEVICE_PAIRING_STAGE1, _bluetooth2.default.DEVICE_SELECTION].indexOf(device.status) > -1 && this.getPairingScreenStage1(),
        device.status === _bluetooth2.default.DEVICE_PAIRING_STAGE2 && this.getPairingScreenStage2()
      );
    }
  }]);
  return DeviceSetupConnection;
}(_react2.default.Component);

DeviceSetupConnection.propTypes = {
  alias: _propTypes2.default.string,
  device: _propTypes2.default.object,
  connectBluetoothDevice: _propTypes2.default.func,
  handleStandardPlay: _propTypes2.default.func,
  hideModal: _propTypes2.default.func,
  inSession: _propTypes2.default.bool,
  updateDevice: _propTypes2.default.func,
  joinClass: _propTypes2.default.func
};